export const SAVE_SYSTEM_VERSION: string = '3';
